import React from 'react';
import PropTypes from 'prop-types';

const Layout02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.33301 0.833496V16.8335M9.83301 3.8335H12.833M9.83301 6.8335H12.833M9.83301 9.8335H10.333M3.83301 16.8335H13.833C15.4899 16.8335 16.833 15.4903 16.833 13.8335V3.8335C16.833 2.17664 15.4899 0.833496 13.833 0.833496H3.83301C2.17615 0.833496 0.833008 2.17664 0.833008 3.8335V13.8335C0.833008 15.4903 2.17615 16.8335 3.83301 16.8335Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Layout02Icon.propTypes = {
  color: PropTypes.string,
};

export default Layout02Icon;
